import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@node_modules/@angular/router';
import { Observable, map } from 'rxjs';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ApplicationService } from '../application/application.service';
import { VacPharmService } from './vac-pharm.service';

@Injectable()
export class VacPharmGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private vacPharmService: VacPharmService,
        private applicationService: ApplicationService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.vacPharmService.getVacPharm(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.vacPharmService.closeVacPharm();
        return true;
    }
}
